<script>
export default {
    name: "pre-rendered-content",
    data() {
        return {
            videoLink: null
        }
    },
    mounted() {
    },
    props: {
        rendered: {
            type: String,

        }
    },
}
</script>

<template>
    <div v-html="rendered"></div>
</template>